import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Box } from 'native-base';
import { Iconography, logUserEvent } from 'fmc-digital-common';
import { InfoCard } from '../../../../components';
import { useLipStore } from '../../../reducers';
import { getInfoCardDetail } from '../../../utils/LIPFilterByUtils';
import { Platform } from 'react-native';
import { AppliedPendingIcon, ClosePendingIcon, CompletedIcon, DonePendingIcon, ProcessingIcon, UnderwritingIcon } from '../../../../assets';
import { useStatusTrackerQuery } from '../../../hooks/TrackingItems';
const LoanStatusInfoCard = ({
  onReturnToHome,
  loanStatus,
  isAllowReturnToHome,
  loanNumber,
  authToken,
  xApiKey,
  selfServUrl,
  onGetInProgressStatus
}) => {
  const {
    setTrackingItemName,
    setTaskName,
    setShowDocUploadModal,
    setShowDocUploadModalWeb,
    clearSelectedFiles
  } = useLipStore(state => state);
  const [infoCardDetail, setInfoCardDetail] = useState({});
  const {
    data,
    error
  } = useStatusTrackerQuery({
    authToken,
    selfServUrl,
    xApiKey,
    loanNumber
  });
  useEffect(() => {
    if (loanStatus < 11) {
      setInfoCardDetail({
        title: 'Your loan details are under review',
        description: 'Thank you for submitting your information. Please check again later for updates.',
        statusTrackerText: 'Apply',
        statusTrackerState: 'InProgress'
      });
    } else if (data && data?.tracker?.length) {
      let currentProgress = data.tracker.find(tracker => tracker.state === 'InProgress');
      if (currentProgress) {
        let infoCard = getInfoCardDetail(currentProgress.text, currentProgress.state);
        setInfoCardDetail(infoCard);
        onGetInProgressStatus(currentProgress.text);
      } else {
        let completedProgress = data.tracker.find(tracker => tracker.state === 'Completed' && tracker.text === 'Done');
        if (completedProgress) {
          let infoCard = getInfoCardDetail(completedProgress.text, completedProgress.state);
          setInfoCardDetail(infoCard);
        } else {
          setInfoCardDetail({});
        }
      }
    } else if (error) {
      setInfoCardDetail({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error, loanStatus]);
  const getIcon = useMemo(() => {
    if (Platform.OS === 'web') {
      if (loanStatus < 11) {
        return /*#__PURE__*/React.createElement(AppliedPendingIcon, null);
      }
      let combinationText = `${infoCardDetail.statusTrackerText}-${infoCardDetail.statusTrackerState}`;
      switch (combinationText) {
        case 'Processing-InProgress':
          {
            return /*#__PURE__*/React.createElement(ProcessingIcon, null);
          }
        case 'Underwriting-InProgress':
          {
            return /*#__PURE__*/React.createElement(UnderwritingIcon, null);
          }
        case 'Closing-InProgress':
          {
            return /*#__PURE__*/React.createElement(ClosePendingIcon, null);
          }
        case 'Done-InProgress':
          {
            return /*#__PURE__*/React.createElement(DonePendingIcon, null);
          }
        case 'Done-Completed':
          {
            return /*#__PURE__*/React.createElement(CompletedIcon, null);
          }
        default:
          return /*#__PURE__*/React.createElement(React.Fragment, null);
      }
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }, [infoCardDetail, loanStatus]);
  const handleUploadMore = useCallback(() => {
    logUserEvent({
      action: 'UploadOtherDocumentsClicked',
      type: 'InfoCardUploadOtherDocuments',
      description: 'Info Card Upload Other Documents'
    });
    clearSelectedFiles();
    setTaskName('Other Documents');
    setTrackingItemName('Additional Documents');
    setShowDocUploadModal(true);
    setShowDocUploadModalWeb(true);
  }, [setShowDocUploadModal, setShowDocUploadModalWeb, setTaskName, setTrackingItemName, clearSelectedFiles]);
  const handleReturnToHome = useCallback(() => {
    logUserEvent({
      action: 'ReturnToHomeClicked',
      type: 'InfoCardReturnToHome',
      description: 'Info Card Return to Home'
    });
    if (onReturnToHome) onReturnToHome();
  }, [onReturnToHome]);
  return infoCardDetail.title ? /*#__PURE__*/React.createElement(Box, {
    my: {
      base: '4',
      sm: '4',
      md: '8',
      lg: '8'
    },
    mt: 0,
    bgColor: 'white.500'
  }, /*#__PURE__*/React.createElement(InfoCard, {
    title: infoCardDetail.title,
    description: infoCardDetail.description,
    subTitle: infoCardDetail.subTitle,
    onReturnToHome: handleReturnToHome,
    uploadOtherDocuments: handleUploadMore,
    icon: getIcon,
    firstButtonProps: isAllowReturnToHome ? {
      variant: 'solid'
    } : undefined,
    secondButtonProps: loanStatus !== 74 ? {
      variant: 'outline',
      leftIcon: /*#__PURE__*/React.createElement(Iconography, {
        name: "upload",
        size: 20,
        color: "blue.900"
      })
    } : undefined
  })) : null;
};
export default /*#__PURE__*/memo(LoanStatusInfoCard);
//# sourceMappingURL=index.js.map